module.exports = __webpack_public_path__ + "img/icon8.d7ef7909.png";